import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 导入全局样式
import './assets/styles/main.css'

// 注意：第三方库样式 (bootstrap.css, fonts.css, style.css) 已在 public/index.html 中引入
// 避免重复导入导致的样式冲突

// 创建Vue应用实例
const app = createApp(App)

// 使用Vue Router
app.use(router)

// 挂载应用到DOM
app.mount('#app')
